// src/admin/SupplementalAttendance.js
import React, { useState, useContext, useMemo } from 'react';
import { StudentContext } from '../StudentContext';
import { supplementalAttendance, supplementalCatechismAttendance } from '../FirebaseService';
import './SupplementalAttendance.css';

const SupplementalAttendance = () => {
  const { studentsData, loadAllData } = useContext(StudentContext);
  const [activeTab, setActiveTab] = useState('church');
  const [idFilter, setIdFilter] = useState('');
  const [nameFilter, setNameFilter] = useState('');
  const [classFilter, setClassFilter] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [supplementDate, setSupplementDate] = useState(new Date().toISOString().split('T')[0]);
  const [supplementTime, setSupplementTime] = useState('');

  const allStudents = useMemo(() => {
    return Object.keys(studentsData || {})
      .flatMap((classId) =>
        (studentsData[classId] || []).map((student) => ({
          ...student,
          classId: classId,
          className: student.className || 'Không xác định',
        }))
      );
  }, [studentsData]);

  const filteredStudents = useMemo(() => {
    return allStudents.filter((student) => {
      const matchesId = student.id?.toLowerCase().includes(idFilter.toLowerCase());
      const matchesName = `${student.holyName || ''} ${student.fullName || ''}`.toLowerCase().includes(nameFilter.toLowerCase());
      const matchesClass = student.className?.toLowerCase().includes(classFilter.toLowerCase());
      return matchesId && matchesName && matchesClass;
    });
  }, [allStudents, idFilter, nameFilter, classFilter]);

  const handleSupplementClick = (student) => {
    setSelectedStudent(student);
    setSupplementDate(new Date().toISOString().split('T')[0]);
    setSupplementTime('');
    setShowModal(true);
  };

  const handleSaveSupplement = async () => {
    if (!supplementDate || !supplementTime || !selectedStudent) {
      alert('Vui lòng nhập đầy đủ thông tin.');
      return;
    }

    const catechistFullName = localStorage.getItem('catechistFullName') || 'Admin';
    const formattedTime = `Có lúc ${supplementTime}`;
    const timeLog = new Date();
    console.log(timeLog);
    

    try {
      if (activeTab === 'church') {
        await supplementalAttendance(selectedStudent.id, catechistFullName, supplementDate, formattedTime, timeLog);
      } else {
        await supplementalCatechismAttendance(selectedStudent.id, catechistFullName, supplementDate, formattedTime, timeLog);
      }
      alert('Đã bổ sung điểm danh thành công.');
      setShowModal(false);
      loadAllData();
    } catch (error) {
      console.error('Error supplementing attendance:', error);
      alert('Lỗi khi bổ sung điểm danh.');
    }
  };

  return (
    <div className="supplemental-attendance-container">
      <h2 className="supp-title">Bổ sung điểm danh</h2>

      {/* Tabs */}
      <div className="supp-tabs-container">
        <button
          className={`supp-tab-button ${activeTab === 'church' ? 'supp-active-tab' : ''}`}
          onClick={() => setActiveTab('church')}
        >
          Điểm danh đi lễ
        </button>
        <button
          className={`supp-tab-button ${activeTab === 'catechism' ? 'supp-active-tab' : ''}`}
          onClick={() => setActiveTab('catechism')}
        >
          Điểm danh học giáo lý
        </button>
      </div>

      {/* Bảng */}
      <div className="supp-table-container">
        <table className="supp-table">
          <thead>
            <tr className="supp-table-header-row">
              <th className="supp-header-cell">ID</th>
              <th className="supp-header-cell">Họ và Tên</th>
              <th className="supp-header-cell">Lớp</th>
              <th className="supp-header-cell">Bổ sung</th>
            </tr>
            <tr className="supp-filter-row">
              <td className="supp-filter-cell">
                <input
                  type="text"
                  value={idFilter}
                  onChange={(e) => setIdFilter(e.target.value)}
                  className="supp-filter-input"
                  placeholder="Tìm ID"
                />
              </td>
              <td className="supp-filter-cell">
                <input
                  type="text"
                  value={nameFilter}
                  onChange={(e) => setNameFilter(e.target.value)}
                  className="supp-filter-input"
                  placeholder="Tìm tên"
                />
              </td>
              <td className="supp-filter-cell">
                <input
                  type="text"
                  value={classFilter}
                  onChange={(e) => setClassFilter(e.target.value)}
                  className="supp-filter-input"
                  placeholder="Tìm lớp"
                />
              </td>
              <td className="supp-filter-cell"></td>
            </tr>
          </thead>
          <tbody className="supp-table-body">
            {filteredStudents.map((student) => (
              <tr key={student.id} className="supp-row">
                <td className="supp-cell">{student.id}</td>
                <td className="supp-cell">{`${student.holyName || ''} ${student.fullName || ''}`}</td>
                <td className="supp-cell">{student.className}</td>
                <td className="supp-cell">
                  <button
                    onClick={() => handleSupplementClick(student)}
                    className="supp-supplement-button"
                  >
                    Bổ sung
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Modal */}
      {showModal && (
        <div className="supp-modal">
          <div className="supp-modal-content">
            <h3 className="supp-modal-title">Bổ sung điểm danh cho {selectedStudent.id}</h3>
            <div className="supp-modal-field">
              <label className="supp-modal-label">Ngày (YYYY-MM-DD):</label>
              <input
                type="date"
                value={supplementDate}
                onChange={(e) => setSupplementDate(e.target.value)}
                className="supp-modal-input"
              />
            </div>
            <div className="supp-modal-field">
              <label className="supp-modal-label">Thời gian (HH:MM):</label>
              <input
                type="time"
                value={supplementTime}
                onChange={(e) => setSupplementTime(e.target.value)}
                className="supp-modal-input"
              />
            </div>
            <div className="supp-modal-buttons">
              <button onClick={() => setShowModal(false)} className="supp-cancel-button">
                Hủy
              </button>
              <button onClick={handleSaveSupplement} className="supp-save-button">
                Lưu
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SupplementalAttendance;